import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { GroupsComponent } from './groups.component';
import { RouterModule } from '@angular/router';
import { GROUPS_ROUTES } from './groups.routes';
import { GroupDetailsComponent } from './group-details/group-details.component';
import { ModalAttachMemberComponent } from './modals/modal-attach-member/modal-attach-member.component';
import { ModalDetachMemberComponent } from './modals/modal-detach-member/modal-detach-member.component';
import { ModalAddGroupComponent } from './modals/modal-add-group/modal-add-group.component';
import { ModalDeleteGroupComponent } from './modals/modal-delete-group/modal-delete-group.component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GroupsEffects } from './effects/groups.effects';
import * as fromGroups from './reducers/groups.reducer';
import { ModalDetachRoleComponent } from './modals/modal-detach-role/modal-detach-role.component';
import { ModalAttachRoleComponent } from './modals/modal-attach-role/modal-attach-role.component';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashDataTableModule } from '@app/shared/modules/smash-data-table/smash-data-table.module';


@NgModule({
  declarations: [
    GroupsComponent,
    GroupDetailsComponent,
    ModalAttachMemberComponent,
    ModalDetachMemberComponent,
    ModalAddGroupComponent,
    ModalDeleteGroupComponent,
    ModalAttachRoleComponent,
    ModalDetachRoleComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashDataTableModule,
    SmashFormsModule,
    RouterModule.forChild(GROUPS_ROUTES),
    EffectsModule.forFeature([GroupsEffects]),
    StoreModule.forFeature(fromGroups.groupsFeatureKey, fromGroups.reducer),
  ]
})
export class GroupsModule { }
